import cx from 'classnames';
import { forwardRef } from 'react';
import type { PropsWithChildren } from 'react';

import { SpotlightTarget } from '@trello/nachos/onboarding-experimental';

import styles from './IslandNav.less';

interface IslandNavProps {
  className?: string;
  isFullWidth?: boolean;
  testId?: string;
  spotlightTargetName?: string;
  hideSpotlight?: boolean;
}

export const IslandNav = forwardRef<
  HTMLElement,
  PropsWithChildren<IslandNavProps>
>(
  (
    {
      children,
      className,
      isFullWidth = false,
      testId,
      spotlightTargetName,
      hideSpotlight,
    },
    ref,
  ) => {
    /**
     * If a spotlight target name is provided, wrap the children in a
     * spotlight and pass the spotlight target name to the spotlight.
     *
     * Normally we would wrap this component in a SpotlightTarget but
     * in this case the nav element would be the target which
     * doesn't result in the correct targeting for the spotlight.
     *
     * We only want to target the children of the nav element with the
     * spotlight.
     *
     *  */
    if (spotlightTargetName && !hideSpotlight) {
      return (
        <nav
          className={cx(
            {
              [styles.islandNav]: true,
              [styles.fullWidth]: isFullWidth,
            },
            className,
          )}
          ref={ref}
          data-testid={testId}
        >
          <SpotlightTarget name={spotlightTargetName}>
            <div className={styles.buttonGroup}>{children}</div>
          </SpotlightTarget>
        </nav>
      );
    }

    return (
      <nav
        className={cx(
          {
            [styles.islandNav]: true,
            [styles.fullWidth]: isFullWidth,
          },
          className,
        )}
        ref={ref}
        data-testid={testId}
      >
        <div className={styles.buttonGroup}>{children}</div>
      </nav>
    );
  },
);
